export const Smartquestions = [
  { id: 1, name: 'cruds.smartTest.selectionSimple' },
  { id: 2, name: 'cruds.smartTest.selectionMultiple' },
  { id: 3, name: 'cruds.smartTest.open' },
]
